import type { ReactNode } from 'react'
import { useSelector } from 'react-redux'

import { useIsReminderStateName } from '~/components/dashboard/reminders/reminderUtils'
import { getClientId, getPatientId } from '~/store/reducers/soap'
import {
  type Reminder,
  type ReminderOrderListHandlers,
  ReminderStateName,
} from '~/types'

import ReminderOrderListItem from './ReminderOrderListItem'
import RhapReminderOrderListItem from './RhapReminderOrderListItem'

export interface ReminderOrderListProps extends ReminderOrderListHandlers {
  disabled?: boolean
  includePrice?: boolean
  isChirp?: boolean
  reminder: Reminder
  title?: ReactNode
}

const ReminderOrderList = ({
  disabled,
  includePrice = false,
  reminder,
  title,
  isCheckedItem,
  onCheckItem,
  onUncheckItem,
  isChirp,
}: ReminderOrderListProps) => {
  const clientId = useSelector(getClientId)
  const patientId = useSelector(getPatientId)

  const isResolved = useIsReminderStateName(
    reminder,
    ReminderStateName.RESOLVED,
  )
  const isDeclined = useIsReminderStateName(
    reminder,
    ReminderStateName.DECLINED,
  )

  if (
    !reminder.soapChargeOrderItems ||
    isResolved ||
    isDeclined ||
    !patientId
  ) {
    return null
  }

  const chirpJSX = (
    <>
      {reminder.soapChargeOrderItems.map((orderItem, index) => (
        <RhapReminderOrderListItem
          isCheckedItem={isCheckedItem}
          isDisabled={disabled}
          key={orderItem.id || index}
          order={orderItem}
          onCheckItem={onCheckItem}
          onUncheckItem={onUncheckItem}
        />
      ))}
    </>
  )

  const notChirpJSX = (
    <>
      {title}
      {reminder.soapChargeOrderItems.map((orderItem, index) => (
        <ReminderOrderListItem
          clientId={clientId}
          disabled={disabled}
          includePrice={includePrice}
          isCheckedItem={isCheckedItem}
          key={orderItem.id || index}
          orderItem={orderItem}
          patientId={patientId}
          onCheckItem={onCheckItem}
          onUncheckItem={onUncheckItem}
        />
      ))}
    </>
  )

  return isChirp ? chirpJSX : notChirpJSX
}

export default ReminderOrderList
